import axios from "axios";
import { AuthClientConfig, SkyportalAuthWebClient } from "./types";
import {
  getUserProfile,
  checkAuth,
  getUserInfo,
  getUserCapabilities,
  getUserContracts,
  getUserRoles,
  getUserPermissions,
} from "./api";
import { makeRejectResponse } from "./interceptors";

export default function createAuthClient(config: AuthClientConfig): SkyportalAuthWebClient {
  const instance = axios.create({
    withCredentials: true,
    ...config.options,
    headers: {
      "Content-Type": "application/json",
      ...config.options?.headers,
    },
    baseURL: config.authApiURL,
  });

  instance.interceptors.response.use((response) => response, makeRejectResponse(config.authWebURL));

  return {
    instance,
    getUserProfile: () => getUserProfile(instance),
    getUserInfo: () => getUserInfo(instance),
    getUserCapabilities: () => getUserCapabilities(instance),
    getUserContracts: () => getUserContracts(instance),
    getUserRoles: () => getUserRoles(instance),
    getUserPermissions: () => getUserPermissions(instance),
    checkAuth: () => checkAuth(instance),
  };
}
